(function () {
    'use strict';

    function ServiceItemOptionInfoController($scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ServiceOptionItemCustom, ServiceOptionItem, $uibModal, DialogService) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.formState = 'list';
        $ctrl.newItem = newItem;
        $ctrl.editItem = editItem;
        $ctrl.backToList = backToList;
        $ctrl.serviceOptionItems = null;
        $ctrl.removeItem = removeItem;
        $ctrl.onQtyType_Change = onQtyType_Change;

        loadAll();

        loadPage();

        function loadAll() {


            if ($ctrl.serviceItemId == undefined || $ctrl.serviceItemId == null)
                $ctrl.serviceOptionItems = [];
            else
                $ctrl.serviceOptionItems = ServiceOptionItemCustom.ServiceOptionItemsByServiceItem($ctrl.serviceItemId).query();


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('serviceOptionInfo');
            translatePartialLoader.addPart('serviceOptionItem');
            translatePartialLoader.addPart('priceInfoDtail');
            translatePartialLoader.addPart('qtyType');
            translatePartialLoader.addPart('qtyUnitType');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
            //
            loadAll();
        }

        function newItem() {
            //
            $ctrl.formState = 'new';
            $ctrl.serviceOptionItem = {};
            $ctrl.serviceOptionItem.qtyType = 'NONE';
            $ctrl.serviceOptionItem.optionInfo.title = 'serviceOption';
            $ctrl.serviceOptionItem.minQty = 0;
            $ctrl.serviceOptionItem.maxQty = 0;
            $ctrl.onCreateNewPriceInfo();

        }

        function editItem(id) {
            //
            $ctrl.formState = 'edit';
            //$ctrl.selectedId=id;
            //$ctrl.onSelectedPriceInfoChanged(id);

            $ctrl.serviceOptionItem = ServiceOptionItem.get(id);

            //

        }

        function backToList() {
            $ctrl.formState = 'list';
            if ($ctrl.serviceItemId == undefined || $ctrl.serviceItemId == null) $ctrl.serviceOptionItems = [];
            else
                loadOptionList();

        }

        function loadOptionList() {
            $ctrl.serviceOptionItems = ServiceOptionItemCustom.ServiceOptionItemsByServiceItem($ctrl.serviceItemId).query();
        }

        function onQtyType_Change() {
            if (!$ctrl.serviceOptionItem.maxQty)
                $ctrl.serviceOptionItem.maxQty = 100;
            if (!$ctrl.serviceOptionItem.minQty)
                $ctrl.serviceOptionItem.minQty = 0;
        }

        function removeItem(optionItem) {

            if ($ctrl.serviceItemId != null && optionItem.optionInfoId) {
                DialogService.showConfirm("عملیات حذف را تائید می فرمایید ؟").then(function () {
                    ServiceOptionItemCustom.removeOptionInfoFromServiceItem($ctrl.serviceItemId, optionItem.optionInfoId).query().$promise.then(function () {
                        loadOptionList();
                    })

                });
            }


            // $uibModal.open({
            //     templateUrl: 'app/entities/service-option-item/service-option-item-delete-dialog.html',
            //     controller: 'ServiceOptionItemDeleteController',
            //     controllerAs: 'vm',
            //     backdrop: 'static',
            //     size: 'md',
            //     resolve: {
            //         entity: ['ServiceOptionItem', function(ServiceOptionItem) {
            //             return ServiceOptionItem.get({id : id}).$promise;
            //         }]
            //     }
            // }).result.then(function(result) {
            //     $ctrl.serviceOptionItems= $ctrl.serviceOptionItems.filter(function (v) {
            //             return (v.id != id )
            //         }
            //     );
            // }, function() {
            //     //nothing
            // });


        }


        $scope.$watch('$ctrl.formState', function () {
            if ($ctrl.formState == 'list')
                loadAll();
        });

    }

    var ServiceItemOptionInfo = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-item-option-info/partial-form.service-item-option-info.html',
        controller: ServiceItemOptionInfoController,
        bindings:
            {
                serviceItemId: '<',
                serviceOptionItem: '=',
                selectedId: '=?',
                formState: '=',
                onSelectedServiceOptionInfoChanged: '=',
                onCreateNewServiceOptionInfo: '='


                /*  items :'<',
                  displaytag:'@?',
                  displayitem:'@?',
                  list:'='*/

            }

    };

    angular
        .module('tikonApp')
        .component('pfServiceItemOptionInfo', ServiceItemOptionInfo)

    ServiceItemOptionInfoController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ServiceOptionItemCustom', 'ServiceOptionItem', '$uibModal', 'DialogService'];


})();

